import { render, staticRenderFns } from "./indexList.vue?vue&type=template&id=50fa127c"
import script from "./indexList.vue?vue&type=script&lang=js"
export * from "./indexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports